import React from "react";
import { useTranslation } from "react-i18next";

const ValidationErrors = ({ validationErrors, compact = false }) => {
  const { t } = useTranslation();

  const formatDateTime = (data) => {
    if (!data) return "___";
    const date = new Date(data);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  if (!validationErrors || validationErrors.length === 0) {
    return null;
  }

  const flattenedErrors = (Array.isArray(validationErrors)
    ? validationErrors
    : []
  ).flatMap((group) => {
    if (Array.isArray(group?.errors) && group.errors.length > 0) {
      return group.errors.map((error) => ({
        ...error,
        error_date: group.error_date,
      }));
    }

    if (group?.error_message || group?.value_string || group?.error_code) {
      return [group];
    }

    return [];
  });

  if (flattenedErrors.length === 0) {
    return null;
  }

  return (
    <div
      className={
        compact
          ? "border-l-2 border-amber-500 bg-amber-50 px-2 py-1"
          : "border border-yellow-300 bg-yellow-50 rounded-lg px-3 py-2 mt-2"
      }
    >
      {/* <div className={`flex items-center gap-1 ${compact ? "mb-1" : "mb-2"}`}>
        <span
          className={`font-bold uppercase tracking-tight text-yellow-700 ${
            compact ? "text-[11px]" : "text-[13px]"
          }`}
        >
          {t("Validation Errors")}
        </span>
      </div> */}
      {flattenedErrors.map((error, errorIdx) => (
        <div key={errorIdx} className={compact ? "mb-1 last:mb-0" : "mb-2"}>
          {error.error_date && (
            <span
              className={`text-yellow-600 font-semibold ${
                compact ? "text-[11px]" : "text-[13px]"
              }`}
            >
              {formatDateTime(error?.error_date)}
            </span>
          )}
          <div
            className={`flex items-start gap-1 py-0.5 leading-tight ${
              compact ? "text-[12px]" : "text-[13px]"
            }`}
          >
            {error.error_code && (
              <span className="font-bold text-yellow-800 whitespace-nowrap">
                {error.error_code}:
              </span>
            )}
            <span className="text-yellow-700">
              {error.error_message || error.message || t("Validation error")}
            </span>
            {error.value_string && (
              <span
                className={`text-yellow-600 font-medium break-all ${
                  compact ? "text-[12px]" : "text-[13px]"
                }`}
              >
                ({error.value_string})
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ValidationErrors;
